<p-dialog
  header="PRINT PURCHASE ORDERS"
  [(visible)]="printPdfModal"
  position="center"
  [modal]="true"
  [style]="{ width: '50vw', height: '20vw' }"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  (onHide)="closePrinfPdfModal()">
  <!-- <h2>PURCHASE ORDER TO INCLUDE</h2> -->

  <p-table
    #dt
    stripedRows
    [rowHover]="true"
    [rows]="25"
    [showCurrentPageReport]="true"
    [scrollable]="true"
    scrollHeight="calc(100vh - 310px)"
    [size]="'small'"
    [resizableColumns]="true"
    [value]="purchaseOrderLine"
    styleClass="p-datatable-customers stockListing"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    [paginator]="false"
    [filterDelay]="0"
    [(selection)]="selectedPurchaseOrderLine"
    [rowHover]="true"
    selectionMode="multiple"
    styleClass="table-listing">
    <ng-template pTemplate="header">
      <tr class="table-head">
        <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
        <th class="type">Purchase order</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-purchaseOrderLine let-rowIndex="rowIndex">
      <tr class="p-selectable-row">
        <td>
          <p-tableCheckbox [value]="purchaseOrderLine"></p-tableCheckbox>
        </td>
        <td class="type">
          {{ purchaseOrderLine }}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="20">No PO found.</td>
      </tr>
    </ng-template>
  </p-table>

  <ng-template pTemplate="footer" class="d-flex gap-2">
    <p-button label="Ok" (click)="openPrinfPdfTab()" />

    <p-button
      label="Cancel"
      (click)="closePrinfPdfModal()"
      variant="outlined"
      severity="secondary" />

    <!-- <p-button
      icon="pi pi-check"
      (click)="openPrinfPdfTab()"
      label="Ok"
      styleClass="p-button-text"></p-button>
    <p-button
      icon="pi pi-times"
      (click)="closePrinfPdfModal()"
      label="Cancel"
      styleClass="p-button-text"></p-button> -->
  </ng-template>
</p-dialog>
